import { useTranslation } from "react-i18next";

const features = [
  { id: "qc", icon: "ri-camera-line", titleKey: "qc.title", bodyKey: "qc.body" },
  { id: "shipping", icon: "ri-truck-line", titleKey: "shipping.title", bodyKey: "shipping.body" },
  { id: "review", icon: "ri-star-line", titleKey: "review.title", bodyKey: "review.body" },
];

export default function InfoSections() {
  const { t } = useTranslation();

  return (
    <>
      <section className="bg-secondary-50">
        <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">
                {t("what.title")}
              </h2>
              <p className="mt-5 text-sm leading-relaxed text-foreground-600 md:text-base">
                {t("what.body")}
              </p>
            </div>
            <div className="flex items-center justify-center rounded-lg border border-background-200 bg-white p-6">
              <span className="flex h-24 w-24 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className="ri-file-list-3-line text-5xl w-16 h-16 flex items-center justify-center"></i>
              </span>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-background-50">
        <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-3">
            {features.map((f) => (
              <div
                key={f.id}
                id={f.id}
                className="flex flex-col rounded-lg border border-background-200 bg-white p-6"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700">
                  <i className={`${f.icon} text-2xl w-6 h-6 flex items-center justify-center`}></i>
                </span>
                <h3 className="mt-5 text-lg font-bold text-foreground-900">{t(f.titleKey)}</h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600">{t(f.bodyKey)}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section id="safety" className="bg-accent-50">
        <div className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-20">
          <div className="mx-auto max-w-3xl text-center">
            <span className="inline-flex h-14 w-14 items-center justify-center rounded-full bg-accent-100 text-accent-700">
              <i className="ri-shield-check-line text-3xl w-8 h-8 flex items-center justify-center"></i>
            </span>
            <h2 className="mt-5 text-2xl font-bold text-foreground-950 md:text-4xl">
              {t("safety.title")}
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              {t("safety.body")}
            </p>
          </div>
        </div>
      </section>
    </>
  );
}